import {
  Fragment,
  Suspense,
  lazy,
} from 'react';
import {
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import { LoadingScreen } from 'components';
import PermissionGuard from 'components/PermissionGuard';

import authenticationRoutes from './authentication';
import dashboardRoutes from './dashboard';

const error404 = {
  component: lazy(() => import('views/Errors/Error404')),
};

const redirect = () => <Redirect to="/dashboard" />;

const landingRoutes = {
  path: '*',
  routes: [error404],
};

const renderRoutes = (routes) =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, index) => {
          const Component = route.component;
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Permission = route.permission
            ? PermissionGuard
            : Fragment;

          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>
                    {route.routes
                      ? (renderRoutes(route.routes))
                      : (<Permission permission={route.permission}>
                        <Component {...props} />
                      </Permission>)}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense >
  ) : null;

function Routes() {
  return renderRoutes([
    {
      exact: true,
      path: '/',
      component: redirect,
    },
    authenticationRoutes,
    dashboardRoutes,
    landingRoutes,
    error404,
  ]);
}

export default Routes;
